var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9164 21.5419C29.3549 18.7346 29.8168 16.106 29.8168 15.4272C29.8168 11.4743 28.2465 7.68319 25.4513 4.88801C22.6562 2.09284 18.8651 0.522522 14.9121 0.522522C12.9539 0.52236 11.0148 0.907923 9.20559 1.65719C7.39638 2.40646 5.75248 3.50476 4.36774 4.88938C2.98301 6.274 1.88457 7.91782 1.13515 9.72697C0.385736 11.5361 -6.68195e-09 13.4752 0 15.4334C0 16.1478 0.469316 18.8295 0.910298 21.6626C0.135499 22.2785 -0.210627 24.0215 0.133043 25.964C0.407734 27.5161 1.05196 28.7971 1.77872 29.413C2.67793 34.3045 9.39245 37.6525 12.8563 39.0728C14.1716 39.6123 15.6465 39.6123 16.9618 39.0728C20.3862 37.6685 26.9972 34.3772 28.0122 29.5719C28.824 29.0447 29.5692 27.6676 29.871 25.9652C30.2319 23.8786 29.8107 22.0297 28.9164 21.5419Z",
    fill: "#688060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.3499eb729c0c3b77457cc1a3a65ed00b.svg";
export { ForwardRef as ReactComponent };